import axios from "axios";
const API_URL = "/api/user/";

const findByNPN = (npn) => {
    return axios
      .get(API_URL, { params: { npn } })
      .then((response) => {
        if (response.data.length > 1) {
          throw new Error("Multiple users found with NPN " + npn);
        };
        if (response.data.length === 0) {
          return null;
        }
        return response.data[0];
      });
  };

  // #85 - email the user a password-reset link (admin staff only).
  const sendReset = (id) => {
    return axios.post(`${API_URL}${id}/send-reset`).then((r) => r.data);
  };

  const UserService = {
    findByNPN,
    sendReset,
  }

export default UserService;
